import React from "react"

import PropTypes from "prop-types"

import * as styles from "./grid.module.scss"

const Grid = ({ children, tight, col, className, nowrap }) => (
  <div
    className={`${className} ${styles.grid} ${
      tight ? styles.grid__tight : ""
    } ${styles[`grid__${col}`]} ${nowrap ? styles.grid__nowrap : ""}`}
  >
    {children}
  </div>
)

export default Grid

Grid.propTypes = {
  children: PropTypes.node,
  tight: PropTypes.bool,
  className: PropTypes.string,
  col: PropTypes.number.isRequired,
  nowrap: PropTypes.bool,
}

Grid.defaultProps = {
  children: null,
  tight: false,
  className: "",
  nowrap: false,
}
